/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_A5Inputs */

const en_to_typescript_faq_a5 = /** @type {(inputs: To_Typescript_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A null value only tells the generator that null occurred, not what the field holds when it is populated. You get the type null, which you should widen by hand to something like string | null. Optionality is a separate signal and comes only from keys missing across array elements.`)
};

const ko_to_typescript_faq_a5 = /** @type {(inputs: To_Typescript_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`null 값은 null이 나타났다는 사실만 알려주고, 채워졌을 때 그 필드가 무엇을 담는지는 알려주지 않습니다. 그래서 null 타입이 나오며, string | null 같은 것으로 직접 넓혀야 합니다. 선택성은 별개의 신호이고 배열 요소들 사이에서 빠진 키에서만 나옵니다.`)
};

const ja_to_typescript_faq_a5 = /** @type {(inputs: To_Typescript_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`null の値は null が現れたという事実だけを伝え、埋まっているときにそのフィールドが何を持つかは伝えません。そのため null 型になり、string | null のようなものへ手で広げる必要があります。任意性は別の手がかりで、配列要素間で欠けたキーからのみ得られます。`)
};

/**
* | output |
* | --- |
* | "A null value only tells the generator that null occurred, not what the field holds when it is populated. You get the type null, which you should widen by han..." |
*
* @param {To_Typescript_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_a5 = /** @type {((inputs?: To_Typescript_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_a5(inputs)
	if (locale === "ko") return ko_to_typescript_faq_a5(inputs)
	return ja_to_typescript_faq_a5(inputs)
});